/* This file was auto-generated with the command "generate-graphql-types" */
import * as Types from '~/graphql/generated/types';

import * as Operations from './mutations';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SendResetPasswordLinkMutationVariables = Types.Exact<{
    tenantId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
    userEmail: Types.Scalars['String']['input'];
    country?: Types.InputMaybe<Types.Scalars['String']['input']>;
    loginChallenge?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;

export type SendResetPasswordLinkMutation = {
    sendResetPasswordLink?: { emailSent?: boolean | null } | null;
};

export type ChangePasswordMutationVariables = Types.Exact<{
    changePasswordRequest: Types.ChangePasswordRequest;
    userId: Types.Scalars['ID']['input'];
    tenantId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
}>;

export type ChangePasswordMutation = { changePassword: { passwordUpdated?: boolean | null } };

export type UpdateUserDetailsForUserMutationVariables = Types.Exact<{
    updateUserRequest: Types.UpdateUserRequest;
    userId: Types.Scalars['ID']['input'];
    tenantId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
}>;

export type UpdateUserDetailsForUserMutation = {
    updateUserDetailsForUser: {
        __typename: 'UserR';
        id: Types.UUID;
        accountType?: Types.AccountType | null;
        ubAccountCode?: string | null;
        email: string;
        firstName?: string | null;
        gender?: Types.Gender | null;
        lastName?: string | null;
        country?: string | null;
        healthProfessionalConfirmation?: boolean | null;
        mobile?: string | null;
        medicalIdentificationNumber?: string | null;
        newsletterSubscription?: boolean | null;
        fieldOfActivity?: Types.FieldOfActivity | null;
        occupationType?: Types.OccupationType | null;
        lastLogin?: string | null;
        roles: Array<Types.Role>;
        isActivated: boolean;
        hasValidActivationToken: boolean;
        createdAt?: string | null;
        dataSharingConsent: boolean;
        privacyPolicyConfirmation: boolean;
        isCompleteOnboardingRequired?: boolean | null;
        academicDegree?: {
            code: string;
            gender?: Types.Gender | null;
            id: string;
            description: Array<{ locale: string; value: string; isSuffix: boolean }>;
        } | null;
        totalPointCertified: Array<{
            amount?: number | null;
            unit: string;
            mainAccreditation?: boolean | null;
        }>;
        totalMembershipPointsEffectedCertified: Array<{
            amount?: number | null;
            unit: string;
            mainAccreditation?: boolean | null;
        }>;
        specialities: Array<{
            id: string;
            code: string;
            description: { translations?: Array<{ locale: string; value: string }> | null };
        }>;
        addresses: Array<{
            __typename: 'AddressR';
            apartmentNumber?: string | null;
            city?: string | null;
            country?: string | null;
            id?: Types.UUID | null;
            postalCode?: string | null;
            street?: string | null;
            isPersonal?: boolean | null;
            fullName?: string | null;
            company?: string | null;
            additionalInformation?: string | null;
        }>;
        company?: {
            id: Types.UUID;
            name?: string | null;
            country?: string | null;
            logoUrl?: string | null;
            companyPage?: {
                id: Types.UUID;
                slug?: string | null;
                publishStatus?: Types.PublishStatusType | null;
            } | null;
        } | null;
    };
};

export type CapturePayPalPaymentMutationVariables = Types.Exact<{
    tenantId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
    clientReference: Types.Scalars['String']['input'];
}>;

export type CapturePayPalPaymentMutation = {
    capturePayPalPayment?: { paymentCaptured: boolean } | null;
};

export type CreateUserPaymentMethodMutationVariables = Types.Exact<{
    tenantId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
    userId: Types.Scalars['ID']['input'];
    userPaymentMethodRequest: Types.UserPaymentMethodRequest;
}>;

export type CreateUserPaymentMethodMutation = {
    createUserPaymentMethod: {
        brand?: string | null;
        default?: boolean | null;
        last4?: string | null;
        reference?: string | null;
        country?: string | null;
        type?: Types.UserPaymentMethodType | null;
    };
};

export type SetDefaultUserPaymentMethodMutationVariables = Types.Exact<{
    tenantId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
    userId: Types.Scalars['ID']['input'];
    paymentMethodReference: Types.Scalars['String']['input'];
    country: Types.Scalars['String']['input'];
}>;

export type SetDefaultUserPaymentMethodMutation = {
    setDefaultUserPaymentMethod: { default: boolean; reference: string };
};

export type CreateSetupIntentMutationVariables = Types.Exact<{
    tenantId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
    userId: Types.Scalars['ID']['input'];
    country: Types.Scalars['String']['input'];
}>;

export type CreateSetupIntentMutation = { createSetupIntent?: { clientSecret: string } | null };

export type UpdateUserMembershipRenewalStatusMutationVariables = Types.Exact<{
    renewalStatus: Types.UserMembershipRenewalStatus;
    userMembershipId: Types.Scalars['ID']['input'];
}>;

export type UpdateUserMembershipRenewalStatusMutation = {
    updateUserMembershipRenewalStatus: {
        id: Types.UUID;
        renewalStatus?: Types.UserMembershipRenewalStatus | null;
    };
};

export type TransitionTrialMembershipManuallyMutationVariables = Types.Exact<{
    tenantId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
    userId: Types.Scalars['ID']['input'];
}>;

export type TransitionTrialMembershipManuallyMutation = {
    transitionTrialMembershipManually: { transitioned: boolean };
};

export type UnpauseMembershipRenewalMutationVariables = Types.Exact<{
    userMembershipId: Types.Scalars['ID']['input'];
}>;

export type UnpauseMembershipRenewalMutation = {
    unpauseMembership: {
        id: Types.UUID;
        pause?: { pauseState?: Types.MembershipPauseState | null } | null;
    };
};

export type SendResetPasswordLinkMutationFn = Apollo.MutationFunction<
    SendResetPasswordLinkMutation,
    SendResetPasswordLinkMutationVariables
>;

/**
 * __useSendResetPasswordLinkMutation__
 *
 * To run a mutation, you first call `useSendResetPasswordLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendResetPasswordLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendResetPasswordLinkMutation, { data, loading, error }] = useSendResetPasswordLinkMutation({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      userEmail: // value for 'userEmail'
 *      country: // value for 'country'
 *      loginChallenge: // value for 'loginChallenge'
 *   },
 * });
 */
export function useSendResetPasswordLinkMutation(
    baseOptions?: Apollo.MutationHookOptions<
        SendResetPasswordLinkMutation,
        SendResetPasswordLinkMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation<
        SendResetPasswordLinkMutation,
        SendResetPasswordLinkMutationVariables
    >(Operations.SendResetPasswordLink, options);
}
export type SendResetPasswordLinkMutationHookResult = ReturnType<
    typeof useSendResetPasswordLinkMutation
>;
export type SendResetPasswordLinkMutationResult =
    Apollo.MutationResult<SendResetPasswordLinkMutation>;
export type SendResetPasswordLinkMutationOptions = Apollo.BaseMutationOptions<
    SendResetPasswordLinkMutation,
    SendResetPasswordLinkMutationVariables
>;
export type ChangePasswordMutationFn = Apollo.MutationFunction<
    ChangePasswordMutation,
    ChangePasswordMutationVariables
>;

/**
 * __useChangePasswordMutation__
 *
 * To run a mutation, you first call `useChangePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changePasswordMutation, { data, loading, error }] = useChangePasswordMutation({
 *   variables: {
 *      changePasswordRequest: // value for 'changePasswordRequest'
 *      userId: // value for 'userId'
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useChangePasswordMutation(
    baseOptions?: Apollo.MutationHookOptions<
        ChangePasswordMutation,
        ChangePasswordMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation<ChangePasswordMutation, ChangePasswordMutationVariables>(
        Operations.changePassword,
        options
    );
}
export type ChangePasswordMutationHookResult = ReturnType<typeof useChangePasswordMutation>;
export type ChangePasswordMutationResult = Apollo.MutationResult<ChangePasswordMutation>;
export type ChangePasswordMutationOptions = Apollo.BaseMutationOptions<
    ChangePasswordMutation,
    ChangePasswordMutationVariables
>;
export type UpdateUserDetailsForUserMutationFn = Apollo.MutationFunction<
    UpdateUserDetailsForUserMutation,
    UpdateUserDetailsForUserMutationVariables
>;

/**
 * __useUpdateUserDetailsForUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserDetailsForUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserDetailsForUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserDetailsForUserMutation, { data, loading, error }] = useUpdateUserDetailsForUserMutation({
 *   variables: {
 *      updateUserRequest: // value for 'updateUserRequest'
 *      userId: // value for 'userId'
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useUpdateUserDetailsForUserMutation(
    baseOptions?: Apollo.MutationHookOptions<
        UpdateUserDetailsForUserMutation,
        UpdateUserDetailsForUserMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation<
        UpdateUserDetailsForUserMutation,
        UpdateUserDetailsForUserMutationVariables
    >(Operations.updateUserDetailsForUser, options);
}
export type UpdateUserDetailsForUserMutationHookResult = ReturnType<
    typeof useUpdateUserDetailsForUserMutation
>;
export type UpdateUserDetailsForUserMutationResult =
    Apollo.MutationResult<UpdateUserDetailsForUserMutation>;
export type UpdateUserDetailsForUserMutationOptions = Apollo.BaseMutationOptions<
    UpdateUserDetailsForUserMutation,
    UpdateUserDetailsForUserMutationVariables
>;
export type CapturePayPalPaymentMutationFn = Apollo.MutationFunction<
    CapturePayPalPaymentMutation,
    CapturePayPalPaymentMutationVariables
>;

/**
 * __useCapturePayPalPaymentMutation__
 *
 * To run a mutation, you first call `useCapturePayPalPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCapturePayPalPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [capturePayPalPaymentMutation, { data, loading, error }] = useCapturePayPalPaymentMutation({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      clientReference: // value for 'clientReference'
 *   },
 * });
 */
export function useCapturePayPalPaymentMutation(
    baseOptions?: Apollo.MutationHookOptions<
        CapturePayPalPaymentMutation,
        CapturePayPalPaymentMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation<CapturePayPalPaymentMutation, CapturePayPalPaymentMutationVariables>(
        Operations.capturePayPalPayment,
        options
    );
}
export type CapturePayPalPaymentMutationHookResult = ReturnType<
    typeof useCapturePayPalPaymentMutation
>;
export type CapturePayPalPaymentMutationResult =
    Apollo.MutationResult<CapturePayPalPaymentMutation>;
export type CapturePayPalPaymentMutationOptions = Apollo.BaseMutationOptions<
    CapturePayPalPaymentMutation,
    CapturePayPalPaymentMutationVariables
>;
export type CreateUserPaymentMethodMutationFn = Apollo.MutationFunction<
    CreateUserPaymentMethodMutation,
    CreateUserPaymentMethodMutationVariables
>;

/**
 * __useCreateUserPaymentMethodMutation__
 *
 * To run a mutation, you first call `useCreateUserPaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserPaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserPaymentMethodMutation, { data, loading, error }] = useCreateUserPaymentMethodMutation({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      userId: // value for 'userId'
 *      userPaymentMethodRequest: // value for 'userPaymentMethodRequest'
 *   },
 * });
 */
export function useCreateUserPaymentMethodMutation(
    baseOptions?: Apollo.MutationHookOptions<
        CreateUserPaymentMethodMutation,
        CreateUserPaymentMethodMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation<
        CreateUserPaymentMethodMutation,
        CreateUserPaymentMethodMutationVariables
    >(Operations.createUserPaymentMethod, options);
}
export type CreateUserPaymentMethodMutationHookResult = ReturnType<
    typeof useCreateUserPaymentMethodMutation
>;
export type CreateUserPaymentMethodMutationResult =
    Apollo.MutationResult<CreateUserPaymentMethodMutation>;
export type CreateUserPaymentMethodMutationOptions = Apollo.BaseMutationOptions<
    CreateUserPaymentMethodMutation,
    CreateUserPaymentMethodMutationVariables
>;
export type SetDefaultUserPaymentMethodMutationFn = Apollo.MutationFunction<
    SetDefaultUserPaymentMethodMutation,
    SetDefaultUserPaymentMethodMutationVariables
>;

/**
 * __useSetDefaultUserPaymentMethodMutation__
 *
 * To run a mutation, you first call `useSetDefaultUserPaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDefaultUserPaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDefaultUserPaymentMethodMutation, { data, loading, error }] = useSetDefaultUserPaymentMethodMutation({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      userId: // value for 'userId'
 *      paymentMethodReference: // value for 'paymentMethodReference'
 *      country: // value for 'country'
 *   },
 * });
 */
export function useSetDefaultUserPaymentMethodMutation(
    baseOptions?: Apollo.MutationHookOptions<
        SetDefaultUserPaymentMethodMutation,
        SetDefaultUserPaymentMethodMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation<
        SetDefaultUserPaymentMethodMutation,
        SetDefaultUserPaymentMethodMutationVariables
    >(Operations.setDefaultUserPaymentMethod, options);
}
export type SetDefaultUserPaymentMethodMutationHookResult = ReturnType<
    typeof useSetDefaultUserPaymentMethodMutation
>;
export type SetDefaultUserPaymentMethodMutationResult =
    Apollo.MutationResult<SetDefaultUserPaymentMethodMutation>;
export type SetDefaultUserPaymentMethodMutationOptions = Apollo.BaseMutationOptions<
    SetDefaultUserPaymentMethodMutation,
    SetDefaultUserPaymentMethodMutationVariables
>;
export type CreateSetupIntentMutationFn = Apollo.MutationFunction<
    CreateSetupIntentMutation,
    CreateSetupIntentMutationVariables
>;

/**
 * __useCreateSetupIntentMutation__
 *
 * To run a mutation, you first call `useCreateSetupIntentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSetupIntentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSetupIntentMutation, { data, loading, error }] = useCreateSetupIntentMutation({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      userId: // value for 'userId'
 *      country: // value for 'country'
 *   },
 * });
 */
export function useCreateSetupIntentMutation(
    baseOptions?: Apollo.MutationHookOptions<
        CreateSetupIntentMutation,
        CreateSetupIntentMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation<CreateSetupIntentMutation, CreateSetupIntentMutationVariables>(
        Operations.createSetupIntent,
        options
    );
}
export type CreateSetupIntentMutationHookResult = ReturnType<typeof useCreateSetupIntentMutation>;
export type CreateSetupIntentMutationResult = Apollo.MutationResult<CreateSetupIntentMutation>;
export type CreateSetupIntentMutationOptions = Apollo.BaseMutationOptions<
    CreateSetupIntentMutation,
    CreateSetupIntentMutationVariables
>;
export type UpdateUserMembershipRenewalStatusMutationFn = Apollo.MutationFunction<
    UpdateUserMembershipRenewalStatusMutation,
    UpdateUserMembershipRenewalStatusMutationVariables
>;

/**
 * __useUpdateUserMembershipRenewalStatusMutation__
 *
 * To run a mutation, you first call `useUpdateUserMembershipRenewalStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMembershipRenewalStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMembershipRenewalStatusMutation, { data, loading, error }] = useUpdateUserMembershipRenewalStatusMutation({
 *   variables: {
 *      renewalStatus: // value for 'renewalStatus'
 *      userMembershipId: // value for 'userMembershipId'
 *   },
 * });
 */
export function useUpdateUserMembershipRenewalStatusMutation(
    baseOptions?: Apollo.MutationHookOptions<
        UpdateUserMembershipRenewalStatusMutation,
        UpdateUserMembershipRenewalStatusMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation<
        UpdateUserMembershipRenewalStatusMutation,
        UpdateUserMembershipRenewalStatusMutationVariables
    >(Operations.updateUserMembershipRenewalStatus, options);
}
export type UpdateUserMembershipRenewalStatusMutationHookResult = ReturnType<
    typeof useUpdateUserMembershipRenewalStatusMutation
>;
export type UpdateUserMembershipRenewalStatusMutationResult =
    Apollo.MutationResult<UpdateUserMembershipRenewalStatusMutation>;
export type UpdateUserMembershipRenewalStatusMutationOptions = Apollo.BaseMutationOptions<
    UpdateUserMembershipRenewalStatusMutation,
    UpdateUserMembershipRenewalStatusMutationVariables
>;
export type TransitionTrialMembershipManuallyMutationFn = Apollo.MutationFunction<
    TransitionTrialMembershipManuallyMutation,
    TransitionTrialMembershipManuallyMutationVariables
>;

/**
 * __useTransitionTrialMembershipManuallyMutation__
 *
 * To run a mutation, you first call `useTransitionTrialMembershipManuallyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransitionTrialMembershipManuallyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transitionTrialMembershipManuallyMutation, { data, loading, error }] = useTransitionTrialMembershipManuallyMutation({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useTransitionTrialMembershipManuallyMutation(
    baseOptions?: Apollo.MutationHookOptions<
        TransitionTrialMembershipManuallyMutation,
        TransitionTrialMembershipManuallyMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation<
        TransitionTrialMembershipManuallyMutation,
        TransitionTrialMembershipManuallyMutationVariables
    >(Operations.transitionTrialMembershipManually, options);
}
export type TransitionTrialMembershipManuallyMutationHookResult = ReturnType<
    typeof useTransitionTrialMembershipManuallyMutation
>;
export type TransitionTrialMembershipManuallyMutationResult =
    Apollo.MutationResult<TransitionTrialMembershipManuallyMutation>;
export type TransitionTrialMembershipManuallyMutationOptions = Apollo.BaseMutationOptions<
    TransitionTrialMembershipManuallyMutation,
    TransitionTrialMembershipManuallyMutationVariables
>;
export type UnpauseMembershipRenewalMutationFn = Apollo.MutationFunction<
    UnpauseMembershipRenewalMutation,
    UnpauseMembershipRenewalMutationVariables
>;

/**
 * __useUnpauseMembershipRenewalMutation__
 *
 * To run a mutation, you first call `useUnpauseMembershipRenewalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnpauseMembershipRenewalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unpauseMembershipRenewalMutation, { data, loading, error }] = useUnpauseMembershipRenewalMutation({
 *   variables: {
 *      userMembershipId: // value for 'userMembershipId'
 *   },
 * });
 */
export function useUnpauseMembershipRenewalMutation(
    baseOptions?: Apollo.MutationHookOptions<
        UnpauseMembershipRenewalMutation,
        UnpauseMembershipRenewalMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation<
        UnpauseMembershipRenewalMutation,
        UnpauseMembershipRenewalMutationVariables
    >(Operations.unpauseMembershipRenewal, options);
}
export type UnpauseMembershipRenewalMutationHookResult = ReturnType<
    typeof useUnpauseMembershipRenewalMutation
>;
export type UnpauseMembershipRenewalMutationResult =
    Apollo.MutationResult<UnpauseMembershipRenewalMutation>;
export type UnpauseMembershipRenewalMutationOptions = Apollo.BaseMutationOptions<
    UnpauseMembershipRenewalMutation,
    UnpauseMembershipRenewalMutationVariables
>;
